<mat-icon fontIcon="fa-exclamation-triangle" fontSet="fas" inline />
<div class="labelWrapper">
	<label>{{ T.LABEL_WARNING | translate }}</label>
	<p class="secondary">{{ text() | translate }}</p>
</div>
